const getFacilityStreet = ({ facility, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (facility && facility['Company Address'] && facility['Company Address'].ID) {
    if (facility['Company Address'].Suite) {
      return `${facility['Company Address'].Street} ${facility['Company Address'].Suite}`;
    }
    return facility['Company Address'].Street;
  }
  return null;
};

export default getFacilityStreet;



// WEBPACK FOOTER //
// ./src/utils/print/getFacilityStreet.js